import { render } from "./property-alarm-dialog.vue?vue&type=template&id=5242f37a&scoped=true&ts=true"
import script from "./property-alarm-dialog.vue?vue&type=script&lang=ts"
export * from "./property-alarm-dialog.vue?vue&type=script&lang=ts"

import "./property-alarm-dialog.vue?vue&type=style&index=0&id=5242f37a&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5242f37a"]])

export default __exports__